import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Search } from "react-bootstrap-table2-toolkit";
import { connect } from "react-redux";
import { Button, Card, CardBody, Col, Container, Input, Row } from "reactstrap";
//Import Breadcrumb
import { useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Columns from "./Columns";
import AutoLogout from "../Authentication/AutoLogout";

import * as boxActionTypes from "../../store/boxes/actionTypes";
const List = ({ list, getAll, remove, mustBeUpdated,disable }) => {
  const history = useHistory();
  const [breadcrumbItems, setBreadcrumbItems] = useState([
    { title: "Configuración", link: "#" },
    { title: "Cajas", link: "#" },
  ]);
  const [pageSize, setPageSize] = useState(10);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [Shearch, setShearch] = useState(null);
  const [PageOptions, setPageOptions] = useState({
    hideSizePerPage: true,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: list?.rowCount ?? 0, // replace later with size(users),
    page: list?.currentPage ?? 1,
    active: true,
    custom: false,
    paginationTotalRenderer: (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        Mostrando {from} a {to} de {size} Resultados
      </span>
    ),
  });

  // const pageOptions = {
  //     sizePerPage: 10,
  //     totalSize: list.length, // replace later with size(users),
  //     custom: true,
  // }

  useEffect(() => {
    setPageOptions({
      hideSizePerPage: true,
      sizePerPage: pageSize,
      showTotal: true,
      totalSize: list?.rowCount ?? 0,
      page: list?.currentPage ?? 1,
      active: true,
      custom: false,
      // sizePerPageList: sizePerPageList,
      paginationTotalRenderer: (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
          Mostrando {from} a {to} de {size} Resultados
        </span>
      ),
      // onSizePerPageChange: handleSizePerPageChange,
    });
  }, [list?.data]);

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  const { SearchBar } = Search;

  const selectRow = {
    mode: "checkbox",
  };

  const handleFilterBoxes = (value) => {
    setShearch(value);
    if(value.length%3 ==0){
      getAll({
        pageNumber: 1,
        PageSize: pageSize,
        filter:value
      });
        // getUsers({Name:value, RoleId})
        setCurrentPage(1);
    }else if(value.length==0){
      getAll({
        pageNumber: 1,
        PageSize: pageSize,
        filter:value
      });
        setCurrentPage(1);
    }
  };
  const handlePageChange = (style, values) => {
  
    setCurrentPage(values?.page);
    getAll({
      pageNumber: values?.page,
      PageSize: pageSize,
      filter:Shearch
    });
  };

  const handleNew = () => history.push("/box/add");
  useEffect(() => {
    getAll({ pageNumber: 1, PageSize: pageSize });
    setCurrentPage(1);
    return () => {};
  }, [history]);

  useEffect(() => {
    if (mustBeUpdated) {
      setCurrentPage(1);
      getAll({ pageNumber: 1, PageSize: pageSize });
    }
  }, [mustBeUpdated]);

  return (
    <React.Fragment>
      <AutoLogout /> {/* Activa el cierre de sesión por inactividad */}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Cajas" breadcrumbItems={breadcrumbItems} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row>
                    <Col sm="4">
                      {/* <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <input placeholder="Buscar" type="text" />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div> */}
                      <div className="text-sm">
                        <Input
                          autoFocus
                          placeholder="Buscar"
                          onChange={({ target: { value } }) =>
                            handleFilterBoxes(value)
                          }
                          color="light"
                          className="btn-rounded "
                        ></Input>
                      </div>
                    </Col>
                    <Col sm="8">
                      <div className="text-sm-end">
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2 me-2"
                          onClick={handleNew}
                        >
                          <i className="mdi mdi-plus me-1" /> Nueva caja
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <BootstrapTable
                    keyField={"id"}
                    responsive
                    bordered={false}
                    pagination={paginationFactory({
                      ...PageOptions,
                      page: CurrentPage,
                    })}
                    striped={true}
                    remote={true}
                    classes={"table align-middle table-nowrap"}
                    headerWrapperClasses={"thead-light"}
                    columns={Columns(remove,disable)}
                    onTableChange={handlePageChange}
                    data={list?.data ?? []}
                    noDataIndication={
                      <span className="no-data-message">
                        No hay datos disponibles
                      </span>
                    }
                  />
                  {/* <PaginationProvider
                    pagination={paginationFactory({
                      ...PageOptions,
                      page: CurrentPage,
                    })}
                    keyField="id"
                    data={list?.data ?? []}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="id"
                        columns={Columns(remove)}
                        data={list?.data ?? []}
                        search
                      >
                        {(toolkitProps) => (
                          <React.Fragment>
                            <Row>
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar
                                      placeholder="Buscar"
                                      {...toolkitProps.searchProps}
                                    />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                                <div className="text-sm-end">
                                  <Button
                                    type="button"
                                    color="success"
                                    className="btn-rounded mb-2 me-2"
                                    onClick={handleNew}
                                  >
                                    <i className="mdi mdi-plus me-1" /> Nueva
                                    caja
                                  </Button>
                                </div>
                              </Col>
                            </Row>

                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={true}
                                defaultSorted={defaultSorted}
                                selectRow={selectRow}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                                onPageChange={handlePageChange}
                              />
                            </div>
                            <div className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </div>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  list: state.Boxes.list,
  mustBeUpdated: state.Boxes?.mustBeUpdated,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getAll: (filter) =>
      dispatch({ type: boxActionTypes.GET_ALL, payload: filter }),
    remove: (payload) =>
      dispatch({ type: boxActionTypes.REMOVE, payload: payload }),
    disable: (payload) =>
      dispatch({ type: boxActionTypes.DISABLE, payload: payload }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(List);
